import http from '../../../Services/api.laravel.http';

export const LogService = {
 	getSingleLog: (id) => http.get('/admin/log/' + id),
  	ArchiveLog: (id) => http.put('/admin/log/archives/' + id),
  	paginateWithSearchLogs: (formParams) => http.post('/admin/log/search', formParams),
}
